

@if (groupings?.length > 0) {
  @for (group of groupings; track group) {
    <div class="question-saved" [id]="group[0]">
      <div class="question-saved__content">
        <div class="question-saved__icon">
          <img src="/assets/icn/class/lg-buildings-combine.svg" class="icon">
        </div>
        <div class="question-saved__name">
          <h6 class="font-16">{{getAddress(group)?.city}}</h6>
          <small>{{getConcatenatedAddress(getAddress(group))}}</small>
          <div class="question-saved__actions d-none d-md-block">
            <a href="javascript:;" (click)="editItem(group[0])" class="text-link">Edit</a>
            <span>|</span>
            <a href="javascript:;" (click)="globalQuestionService.setSelectedLocationItem(group[0])" class="action-remove text-link">Remove</a>
          </div>
        </div>
        <div class="question-saved__cost d-none d-md-block">
          <p><strong>R 130</strong> /mo</p>
        </div>
      </div>
      <!-- mobile actions and cost tray-->
      <div class="question-saved__tray d-md-none">
        <div class="question-saved__actions">
          <a href="javascript:;" (click)="editItem(group[0])" class="text-link">Edit</a>
          <span>|</span>
          <a href="javascript:;" (click)="globalQuestionService.setSelectedLocationItem(group[0])" class="action-remove text-link">Remove</a>
        </div>
        <div class="question-saved__cost">
          <p><strong>R 130</strong> /mo</p>
        </div>
      </div>
    </div>
  }
}

@if (max_item_id != null) {
  <app-question-mini-flow-controller
    [question]="childQuestion"
    [max_item_id]="max_item_id"
    (questionAnswer)="submitResponse($event)">
  </app-question-mini-flow-controller>
}


